// src/app/routes/withRoleProtection.tsx
import type { UserRoles } from '@/shared/utils/types/roles'
import type { QueryClient } from '@tanstack/react-query'
import type { LoaderFunctionArgs } from 'react-router-dom'
import type { ComponentType } from 'react'
import { ProtectedRoute } from './protectedRoute'

type ModuleWithLoader = {
  clientLoader?: (queryClient: QueryClient) => (params: LoaderFunctionArgs<unknown>) => Promise<unknown>
  default: ComponentType
}

// export const convertWithRoles = (queryClient: QueryClient, roles?: { all?: UserRoles[]; any?: UserRoles[] }) => (m: ModuleWithLoader) => {
//   const { clientLoader, default: Component, ...rest } = m

//   const WrappedComponent = roles
//     ? () => (
//         <ProtectedRoute roles={roles.all} anyRoles={roles.any}>
//           <Component />
//         </ProtectedRoute>
//       )
//     : Component

//   return {
//     ...rest,
//     loader: clientLoader ? clientLoader(queryClient) : undefined,
//     Component: WrappedComponent,
//   }
// }
const ADMIN_ROLE = 'frontend-admin' as UserRoles

export const convertWithRoles = (queryClient: QueryClient, roles?: { all?: UserRoles[]; any?: UserRoles[] }) => (m: ModuleWithLoader) => {
  const { clientLoader, default: Component, ...rest } = m

  const WrappedComponent = roles
    ? () => (
        <ProtectedRoute roles={roles.all} anyRoles={roles.any}>
          <Component />
        </ProtectedRoute>
      )
    : Component

  return {
    ...rest,
    loader: clientLoader ? clientLoader(queryClient) : undefined,
    Component: WrappedComponent,
  }
}

export const convertWithAdminRole = (queryClient: QueryClient) =>
  convertWithRoles(queryClient, {
    any: [ADMIN_ROLE],
  })
